export const verify_wall_verified_actions = {
  cta_continue: "Continue",
};
